import React, { useState } from "react";
import { ProfileContextProvider } from "common/ProfileContext";
import { FilterContextProvider } from "common/FilterContext";
import { BqnContextProvider } from "common/BqnContext";
import Modals from "Modals";
import { ModalsContextProvider } from "common/ModalsContext";
import SidebarMenu from "menu/SidebarMenu";
import { AppRoutes } from "AppRoutes";
import Chat from "common/chat/Chat";
import { GeminiContextProvider } from "common/chat/GeminiContext";
import { ChatButton } from "common/chat/ChatButton";
import styled from "styled-components";

const RightMargin = styled.div`
  margin-right: ${({ $docked }) => ($docked ? "calc(25vw - 15px)" : "0px")};
  transition: margin-right 0.3s ease;
`;
import { ConnectionLostModal } from "common/ConnectionLostModal";

export default function App() {
  const [openChatbot, setOpenChatbot] = useState(false);
  const [sideChatbot, setSideChatbot] = useState(false);

  const toggleChatbot = () => setOpenChatbot((value) => !value);

  return (
    <ModalsContextProvider>
      <ProfileContextProvider>
        <BqnContextProvider>
          <GeminiContextProvider>
            <SidebarMenu toggleChatbot={toggleChatbot} />
            <FilterContextProvider>
              <Modals />
              <RightMargin $docked={sideChatbot}>
                <AppRoutes />
              </RightMargin>
            </FilterContextProvider>
            <ChatButton onClick={toggleChatbot} />
            <Chat
              open={openChatbot}
              onToggle={toggleChatbot}
              onSide={setSideChatbot}
            />
          </GeminiContextProvider>
        </BqnContextProvider>
      </ProfileContextProvider>
      <ConnectionLostModal />
    </ModalsContextProvider>
  );
}
